<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";
    import T from "@components/T.svelte";

    import { wishlistThemeContextToken } from "./WishlistTheme/WIshlistThemeContextToken";

    export let loading: boolean;
    export let namespace: string;
    export let translationKey: string;
    export let disabled = false;

    const wishlistBranding = getTypedContext(wishlistThemeContextToken);

    const dispatch = createEventDispatcher();
</script>

<div
    class={CN("gw-wl-add-to-cart-btn", {
        "--filled":
            wishlistBranding.wishlistDrawerAndPageSettings.buttonsStyle ===
            "filled",
        "--outlined":
            wishlistBranding.wishlistDrawerAndPageSettings.buttonsStyle ===
            "outlined",
    })}
>
    <Button
        block
        on:click={() => dispatch("addToCart")}
        {loading}
        {disabled}
        variant="contained"
    >
        <T {namespace} {translationKey} />
    </Button>
</div>

<style lang="postcss">
    .gw-wl-add-to-cart-btn {
        display: flex;
        width: 100%;
        align-items: center;
        box-shadow: 0 0 0 1px
            var(--gw-wl-wishlistDrawerAndPageSettings-buttonsColor);
        border-radius: calc(
            1px * var(--gw-wl-wishlistDrawerAndPageSettings-buttonsBorderRadius)
        );

        &.--filled {
            background-color: var(
                --gw-wl-wishlistDrawerAndPageSettings-buttonsColor
            );
            color: var(--gw-wl-wishlistDrawerAndPageSettings-buttonsFontColor);
            border: 0;
        }

        & :global(.gw-btn.gw-button.--contained) {
            box-shadow: none;
            background: none;
        }
    }
</style>
